import { render } from "./shipping-confirmation.vue?vue&type=template&id=a4f73856&ts=true"
import script from "./shipping-confirmation.vue?vue&type=script&lang=ts"
export * from "./shipping-confirmation.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__